'use strict';

import Backbone from 'backbone';
import _ from 'lodash';
import template from './../templates/footer.ejs'; 
import templateCss from './../templates/footer.css.ejs'; 
import CSSView from './css';

export default Backbone.View.extend({
    template: template,
    className: 'footer',
    /**
     *
     */
    initialize: function(options) {
    	_.bindAll(this, 'render');
    	this.uid = options.uid;
    	this.styleID =	this.className + _.uniqueId(Math.random()+""+new Date().getTime()).replace('.','');
    	this.$el.addClass(this.styleID);
    },

    /**
     *
     */
    render: function() {
        if(this.CSSView) {
            this.CSSView.remove();
        }
        console.log('LNV-9: ', this.model);

        this.CSSView = new CSSView({
                model: this.model['customizations'],
                namespace: '#' + this.uid + ' footer',
                template: templateCss
        });
        
        Backbone.$('head').append(this.CSSView.render().$el);

        this.$el.html( this.template( _.extend( 
            {}, 
            this.model ) ) );

        return this;
    },

    remove: function() {
        this.model = null;
        this.off();
        Backbone.View.prototype.remove.call(this);
    }
});